import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, Pager, FormControl } from 'react-bootstrap';
import Constants from '../../config/constants';
import { translate } from 'react-i18next';
import Layout from '../../components/layout/Layout';
import ProjectCard from '../../components/projectcard/ProjectCard';
import ProjectCreateModal from '../../modal/projects/ProjectCreateModal';
import InvitationListModal from '../../modal/member/InvitationListModal';
import { defaultRejectHandler } from '../../utils/utility';
import { convertProject } from '../../utils/converter';

import {
  clearErrorProject,
  getProject,
  listAllProject,
} from '../../redux/projects/projects_actions';

import '../../components/default.css';

class ProjectsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowCreateModal: false,
      isShowInvModal: false,
      isCreated: false,
      page: 0,
      searchText: '',
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.listProject(this.state.page, this.state.searchText);
  }

  componentWillUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
  }

  listProject() {
    const { page } = this.state;
    this.props.listProject(page, this.state.searchText);
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 }, () => this.listProject());
  }

  prevPage() {
    this.setState({ page: Math.max(this.state.page - 1, 0)}, () => this.listProject());
  }

  navigateProjectDetail(project) {
    if (project.is_mixed_use) {
      this.props.history.push(`/projects/mixeduse/${project.id}`);
    }
    else {
      this.props.history.push(`/projects/${project.id}`);
    }
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissInvModal() {
    this.props.clearError();
    this.setState({ isShowInvModal: false });
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isInvAccepting && nextProps.isInvAccepting !== this.props.isInvAccepting && !nextProps.invErrorMessage) {
      this.props.listProject();
    }
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true  });
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li key="project-create-menu">
        <a href="#"
          id="project-create"
          data-toggle="modal"
          data-target="#create-project"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{t('create project')}</span>
        </a>
      </li>,
      <li key="project-invitation">
        <a
          href="#"
          id="project-invitation"
          onClick={() => this.setState({ isShowInvModal: true })}
        >
          <i className="fas fa-inbox" />
          <span className="menu-text">{t('invitation inbox')}</span>
        </a>
      </li>,
    ];
  }

  render() {
    const {
      projects,
      totalProjectCount,
      t,
    } = this.props;

    const keyword = (this.state.searchText || '').toLowerCase();
    const filteredProjects = projects
      ? projects.filter(p => (p.name || '').toLowerCase().indexOf(keyword) !== -1)
      : [];
    const isEnablePrevBtn = this.state.page !== 0;
    const pageSize = 10;
    const isEnableNextBtn = (this.state.page + 1) * pageSize < totalProjectCount;
  
    const breadcrumbItems = [
      { name: t('projects'), path: '/projects' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_project.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <Grid>
          <Row style={{ marginBottom: 15 }}>
            <Col xs={12} sm={6} md={4} lg={3}>
              <FormControl
                type="text"
                placeholder={t('search name')}
                value={this.state.searchText}
                onChange={e => {
                  const value = e.target.value;
                  this.setState({ searchText: value, page: 0 }, () => {
                    if (this.searchTimer) clearTimeout(this.searchTimer);
                    this.searchTimer = setTimeout(() => {
                      this.listProject();
                    }, Constants.DEBOUNCE_TIME || 250);
                  });
                }}
              />
            </Col>
          </Row>
          <Row>
            <ProjectCreateModal
              show={this.state.isShowCreateModal}
              onHide={() => this.dismissCreateModal()}
            />
            <InvitationListModal
              show={this.state.isShowInvModal}
              onHide={() => this.dismissInvModal()}
            />
            {filteredProjects
              ? filteredProjects.map((project, index) => (
                  <Col xs={12} sm={6} md={4} lg={3} key={index}>
                    <ProjectCard
                      project={convertProject(project)}
                      onClick={() => this.navigateProjectDetail(project)}
                    />
                  </Col>
                ))
              : null}
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            <Pager>
              <Pager.Item href="#" disabled={!isEnablePrevBtn} onClick={() => this.prevPage()}>
                {t("previous")}
              </Pager.Item>{' '}
              <Pager.Item href="#" disabled={!isEnableNextBtn} onClick={() => this.nextPage()}>
                {t("next")}
              </Pager.Item>
            </Pager>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project.orderedIds.map(id => state.project.objects[id]),
  totalProjectCount: state.project.totalCount,
  errorMessage: state.project.errorMessage,
  isInvAccepting: state.projectInvitation.isAccepting,
  invErrorMessage: state.projectInvitation.errorMessage,
  isCreating: state.project.creating,
});

const mapDispatchToProps = dispatch => ({
  listProject: (page, searchText) => defaultRejectHandler(dispatch(listAllProject(page, 10, searchText))),
  getProject: id => defaultRejectHandler(dispatch(getProject(id))),
  clearError: () => dispatch(clearErrorProject()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ProjectsPage),
);



// WEBPACK FOOTER //
// ./src/pages/projects/ProjectsPage.js